import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex items-start justify-between gap-4 border-b border-slate-200 px-5 py-4" }
const _hoisted_2 = { class: "text-lg font-bold capitalize text-slate-900" }
const _hoisted_3 = { class: "max-h-[75vh] overflow-y-auto bg-white" }
const _hoisted_4 = { class: "divide-y divide-slate-100" }
const _hoisted_5 = { class: "grid grid-cols-1 gap-3 px-5 py-3 md:grid-cols-[170px_1fr] md:items-center" }
const _hoisted_6 = { class: "grid grid-cols-1 gap-3 px-5 py-3 md:grid-cols-[170px_1fr] md:items-center" }
const _hoisted_7 = { class: "grid grid-cols-1 gap-3 px-5 py-3 md:grid-cols-[170px_1fr] md:items-center" }
const _hoisted_8 = { class: "grid grid-cols-1 gap-3 px-5 py-3 md:grid-cols-[170px_1fr] md:items-center" }
const _hoisted_9 = { class: "grid grid-cols-1 gap-3 px-5 py-3 md:grid-cols-[170px_1fr] md:items-center" }
const _hoisted_10 = {
  key: 0,
  class: "mt-1 text-xs text-slate-500"
}
const _hoisted_11 = { class: "grid grid-cols-1 gap-3 px-5 py-3 md:grid-cols-[170px_1fr] md:items-center" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "grid grid-cols-1 gap-3 px-5 py-3 md:grid-cols-[170px_1fr] md:items-center" }
const _hoisted_14 = { class: "grid grid-cols-1 gap-3 px-5 py-3 md:grid-cols-[170px_1fr] md:items-center" }
const _hoisted_15 = { class: "grid grid-cols-1 gap-3 px-5 py-3 md:grid-cols-[170px_1fr] md:items-center" }
const _hoisted_16 = { class: "grid grid-cols-1 gap-3 px-5 py-3 md:grid-cols-[170px_1fr] md:items-center" }
const _hoisted_17 = { class: "grid grid-cols-1 gap-3 px-5 py-3 md:grid-cols-[170px_1fr] md:items-center" }
const _hoisted_18 = { class: "grid grid-cols-1 gap-3 px-5 py-3 md:grid-cols-[170px_1fr] md:items-start" }
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "flex flex-wrap gap-2" }
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "grid grid-cols-1 gap-3 px-5 py-3 md:grid-cols-[170px_1fr] md:items-center" }
const _hoisted_23 = { class: "grid gap-2 sm:grid-cols-2" }
const _hoisted_24 = { class: "inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm font-medium text-slate-700" }
const _hoisted_25 = { class: "inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm font-medium text-slate-700" }
const _hoisted_26 = { class: "grid grid-cols-1 gap-3 px-5 py-3 md:grid-cols-[170px_1fr] md:items-start" }
const _hoisted_27 = { class: "space-y-3" }
const _hoisted_28 = { class: "inline-flex rounded-lg border border-slate-200 bg-slate-50 p-1" }
const _hoisted_29 = {
  key: 2,
  class: "flex items-start gap-3"
}
const _hoisted_30 = ["src"]
const _hoisted_31 = { class: "flex items-center justify-end gap-2 border-t border-slate-200 bg-slate-50 px-5 py-3" }
const _hoisted_32 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppSelect = _resolveComponent("AppSelect")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[45] || (_cache[45] = _createElementVNode("div", { class: "fixed inset-0 z-[998] bg-slate-900/50 backdrop-blur-sm" }, null, -1)),
    _createElementVNode("div", {
      class: "fixed inset-0 z-[999] flex items-center justify-center p-4",
      onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
    }, [
      _createElementVNode("div", {
        ref: "modalContent",
        class: "w-full max-w-[760px]",
        onClick: _cache[23] || (_cache[23] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createElementVNode("form", {
          onSubmit: _cache[22] || (_cache[22] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"])),
          class: "overflow-hidden rounded-lg border border-slate-200 bg-white shadow-2xl"
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", null, [
              _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.title), 1),
              _cache[25] || (_cache[25] = _createElementVNode("p", { class: "mt-1 text-sm text-slate-500" }, "Catat donasi manual, nominal, kanal notifikasi, dan bukti transfer jika ada.", -1))
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "rounded-lg p-1.5 text-slate-400 transition hover:bg-slate-100 hover:text-slate-700",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            }, [...(_cache[26] || (_cache[26] = [
              _createElementVNode("svg", {
                class: "h-5 w-5",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M6 18L18 6M6 6l12 12"
                })
              ], -1)
            ]))])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[27] || (_cache[27] = _createElementVNode("div", null, [
                  _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, [
                    _createTextVNode("Nama "),
                    _createElementVNode("span", { class: "text-red-500" }, "*")
                  ]),
                  _createElementVNode("p", { class: "mt-0.5 text-xs text-slate-400" }, "Nama donatur yang dicatat.")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.data.name) = $event)),
                  required: "",
                  type: "text",
                  class: "block w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-800 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20",
                  placeholder: "mis. Budi Santoso"
                }, null, 512), [
                  [_vModelText, _ctx.formData.data.name]
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[28] || (_cache[28] = _createElementVNode("div", null, [
                  _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, "Email"),
                  _createElementVNode("p", { class: "mt-0.5 text-xs text-slate-400" }, "Salah satu dari email atau No WA wajib diisi.")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.data.email) = $event)),
                  type: "email",
                  class: "block w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-800 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20",
                  placeholder: "nama@email.com"
                }, null, 512), [
                  [_vModelText, _ctx.formData.data.email]
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[29] || (_cache[29] = _createElementVNode("div", null, [
                  _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, "No WA"),
                  _createElementVNode("p", { class: "mt-0.5 text-xs text-slate-400" }, "Nomor WhatsApp untuk notifikasi donasi.")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.data.noWhatsapp) = $event)),
                  type: "text",
                  class: "block w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-800 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20",
                  placeholder: "08123456789"
                }, null, 512), [
                  [_vModelText, _ctx.formData.data.noWhatsapp]
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[30] || (_cache[30] = _createElementVNode("div", null, [
                  _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, "Jenis Donasi"),
                  _createElementVNode("p", { class: "mt-0.5 text-xs text-slate-400" }, "Kategori pencatatan donasi.")
                ], -1)),
                _createVNode(_component_AppSelect, {
                  modelValue: _ctx.formData.data.donationType,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.data.donationType) = $event)),
                  options: _ctx.donationTypeSelectOptions,
                  "button-class": "bg-slate-50 text-slate-800 focus:ring-blue-500/20"
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[33] || (_cache[33] = _createElementVNode("div", null, [
                  _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, [
                    _createTextVNode("Fakultas "),
                    _createElementVNode("span", { class: "text-red-500" }, "*")
                  ]),
                  _createElementVNode("p", { class: "mt-0.5 text-xs text-slate-400" }, "Opsional, untuk kode unik fakultas.")
                ], -1)),
                _createElementVNode("div", null, [
                  _createVNode(_component_AppSelect, {
                    modelValue: _ctx.facultyId,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.facultyId) = $event)),
                    options: _ctx.facultyOptions,
                    "button-class": "bg-slate-50 text-slate-800 focus:ring-blue-500/20"
                  }, null, 8, ["modelValue", "options"]),
                  (_ctx.selectedFaculty)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                        _cache[31] || (_cache[31] = _createTextVNode(" Nominal akhir akan ditambah kode unik ", -1)),
                        _createElementVNode("b", null, _toDisplayString(_ctx.selectedFaculty.kodeUnik), 1),
                        _cache[32] || (_cache[32] = _createTextVNode(". ", -1))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _cache[34] || (_cache[34] = _createElementVNode("div", null, [
                  _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, [
                    _createTextVNode("Nominal "),
                    _createElementVNode("span", { class: "text-red-500" }, "*")
                  ]),
                  _createElementVNode("p", { class: "mt-0.5 text-xs text-slate-400" }, "Jumlah uang yang didonasikan.")
                ], -1)),
                _createElementVNode("input", {
                  value: _ctx.formattedAmount,
                  required: "",
                  type: "text",
                  inputmode: "numeric",
                  class: "block w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-800 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20",
                  placeholder: "Rp 0",
                  onInput: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onAmountInput && _ctx.onAmountInput(...args)))
                }, null, 40, _hoisted_12)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _cache[35] || (_cache[35] = _createElementVNode("div", null, [
                  _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, [
                    _createTextVNode("Tanggal Masuk "),
                    _createElementVNode("span", { class: "text-red-500" }, "*")
                  ]),
                  _createElementVNode("p", { class: "mt-0.5 text-xs text-slate-400" }, "Tanggal uang masuk.")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.data.date) = $event)),
                  required: "",
                  type: "date",
                  class: "block w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-800 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20"
                }, null, 512), [
                  [_vModelText, _ctx.formData.data.date]
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _cache[36] || (_cache[36] = _createElementVNode("div", null, [
                  _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, "Bank"),
                  _createElementVNode("p", { class: "mt-0.5 text-xs text-slate-400" }, "Bank atau sumber transfer.")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.data.bank) = $event)),
                  type: "text",
                  class: "block w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-800 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20",
                  placeholder: "mis. BCA"
                }, null, 512), [
                  [_vModelText, _ctx.formData.data.bank]
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _cache[37] || (_cache[37] = _createElementVNode("div", null, [
                  _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, "Bank"),
                  _createElementVNode("p", { class: "mt-0.5 text-xs text-slate-400" }, "Bank atau sumber transfer.")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.data.bank) = $event)),
                  type: "text",
                  class: "block w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-800 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20",
                  placeholder: "mis. BCA"
                }, null, 512), [
                  [_vModelText, _ctx.formData.data.bank]
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _cache[38] || (_cache[38] = _createElementVNode("div", null, [
                  _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, "Metode Pembayaran"),
                  _createElementVNode("p", { class: "mt-0.5 text-xs text-slate-400" }, "Kanal atau sumber bayar.")
                ], -1)),
                _createVNode(_component_AppSelect, {
                  modelValue: _ctx.formData.data.paymentMethod,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.data.paymentMethod) = $event)),
                  options: _ctx.paymentMethodOptions,
                  "button-class": "bg-slate-50 text-slate-800 focus:ring-blue-500/20"
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _cache[39] || (_cache[39] = _createElementVNode("div", null, [
                  _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, "Status Pembayaran"),
                  _createElementVNode("p", { class: "mt-0.5 text-xs text-slate-400" }, "Status transaksi.")
                ], -1)),
                _createVNode(_component_AppSelect, {
                  modelValue: _ctx.formData.data.paymentStatus,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.data.paymentStatus) = $event)),
                  options: _ctx.paymentStatusOptions,
                  "button-class": "bg-slate-50 text-slate-800 focus:ring-blue-500/20"
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _cache[40] || (_cache[40] = _createElementVNode("div", { class: "md:pt-2" }, [
                  _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, [
                    _createTextVNode("Notifikasi "),
                    _createElementVNode("span", { class: "text-red-500" }, "*")
                  ]),
                  _createElementVNode("p", { class: "mt-0.5 text-xs text-slate-400" }, "Pilih kanal pengiriman notifikasi.")
                ], -1)),
                _createElementVNode("div", null, [
                  _createElementVNode("input", {
                    class: "sr-only",
                    value: _ctx.notificationValue,
                    required: "",
                    tabindex: "-1"
                  }, null, 8, _hoisted_19),
                  _createElementVNode("div", _hoisted_20, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notificationOptions, (option) => {
                      return (_openBlock(), _createElementBlock("label", {
                        key: option.value,
                        class: "inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm font-medium text-slate-700"
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.data.notification) = $event)),
                          type: "checkbox",
                          value: option.value,
                          class: "rounded border-slate-300 text-blue-700 focus:ring-blue-500"
                        }, null, 8, _hoisted_21), [
                          [_vModelCheckbox, _ctx.formData.data.notification]
                        ]),
                        _createTextVNode(" " + _toDisplayString(option.label), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _cache[43] || (_cache[43] = _createElementVNode("div", null, [
                  _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, "Publikasi Nama"),
                  _createElementVNode("p", { class: "mt-0.5 text-xs text-slate-400" }, "Pengaturan tampilan nama donatur.")
                ], -1)),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("label", _hoisted_24, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.data.nameIsHidden) = $event)),
                      type: "checkbox",
                      class: "rounded border-slate-300 text-blue-700 focus:ring-blue-500"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.formData.data.nameIsHidden]
                    ]),
                    _cache[41] || (_cache[41] = _createTextVNode(" Sembunyikan nama ", -1))
                  ]),
                  _createElementVNode("label", _hoisted_25, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.data.isHambaAllah) = $event)),
                      type: "checkbox",
                      class: "rounded border-slate-300 text-blue-700 focus:ring-blue-500"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.formData.data.isHambaAllah]
                    ]),
                    _cache[42] || (_cache[42] = _createTextVNode(" Hamba Allah ", -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _cache[44] || (_cache[44] = _createElementVNode("div", { class: "md:pt-2" }, [
                  _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, "Bukti Transfer Manual"),
                  _createElementVNode("p", { class: "mt-0.5 text-xs text-slate-400" }, "Opsional untuk donasi manual. Midtrans memakai status transaksi.")
                ], -1)),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["rounded-md px-3 py-1.5 text-xs font-semibold transition", _ctx.imageMode === 'url' ? 'bg-white text-blue-700 shadow-sm' : 'text-slate-500 hover:text-slate-700']),
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.setImageMode('url')))
                    }, " URL ", 2),
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["rounded-md px-3 py-1.5 text-xs font-semibold transition", _ctx.imageMode === 'upload' ? 'bg-white text-blue-700 shadow-sm' : 'text-slate-500 hover:text-slate-700']),
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.setImageMode('upload')))
                    }, " Upload ", 2)
                  ]),
                  (_ctx.imageMode === 'url')
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.imageUrlInput) = $event)),
                        type: "text",
                        class: "block w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-800 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20",
                        placeholder: "https://...",
                        onInput: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.onImageUrlInput && _ctx.onImageUrlInput(...args)))
                      }, null, 544)), [
                        [_vModelText, _ctx.imageUrlInput]
                      ])
                    : (_openBlock(), _createElementBlock("input", {
                        key: 1,
                        type: "file",
                        accept: "image/*",
                        class: "block w-full text-sm text-slate-600 file:mr-3 file:rounded-lg file:border-0 file:bg-blue-50 file:px-3 file:py-2 file:text-sm file:font-semibold file:text-blue-700 hover:file:bg-blue-100",
                        onChange: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.onImageChange && _ctx.onImageChange(...args)))
                      }, null, 32)),
                  (_ctx.imagePreview)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _createElementVNode("img", {
                          src: _ctx.imagePreview,
                          alt: "Preview bukti bayar",
                          class: "h-20 w-20 rounded-lg border border-slate-200 object-cover"
                        }, null, 8, _hoisted_30),
                        _createElementVNode("button", {
                          type: "button",
                          class: "rounded-lg bg-red-50 px-3 py-1.5 text-xs font-semibold text-red-600 hover:bg-red-100",
                          onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.removeImage && _ctx.removeImage(...args)))
                        }, " Hapus gambar ")
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
              class: "rounded-lg border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-slate-600 hover:bg-slate-100"
            }, " Batal "),
            _createElementVNode("button", {
              type: "submit",
              disabled: _ctx.isLoading,
              class: "rounded-lg bg-blue-800 px-5 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-60"
            }, _toDisplayString(_ctx.isLoading ? 'Menyimpan...' : 'Simpan'), 9, _hoisted_32)
          ])
        ], 32)
      ], 512)
    ])
  ], 64))
}